import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { AttachFile, Print } from '@material-ui/icons';
import MaterialTable from 'material-table';
import addIcon from '../../../../../assets/add.svg';

import Moment from 'moment';
import { Tooltip, Paper } from '@material-ui/core';
import PickupOrderAwb from '../../../../../models/PickupOrderAwb';
import { Badge } from '@material-ui/core';
import commonStyles from '../../../../common/common.module.css';
import PickupOrderGha from '../../../../../models/PickupOrderGha';

const iconFontSize = 20;
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    red:{
      backgroundColor: 'red !important',
      color:'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    green:{
      backgroundColor: 'green !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    manualEntryBtn: {
      width: '28px'
    },
    plus: {
      textAlign: 'right',
    },
    selected: {
      background: 'orange'
    },
    tableSection: {
      '& td':{
        color : 'inherit !important'
      }
    },
    ordersPaper: {
      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }
    },
    specials: {
      display: 'flex',
      flexDirection: 'column',
    },
    gap4px: {
      gap: '4px',
    },
    flexSpcl: {
      flexWrap: 'nowrap'
    },
    '@media (max-width: 991px)': {
      flexSpcl: {
        flexWrap: 'wrap'
      },
    }
  });


interface DooAwbListProps {
  classes: any;
  awbs: Array<PickupOrderAwb>;
  printAwbInfoClicked: (awbCode: string, awbNumber: string, version: number) => void;
  openDialog: (type: string, awbCode: string, awbNumber: string, awbVer: number) => void;
  addAwb: Function;
  doo: PickupOrderGha;
  changed: boolean;
  selectedAwbNumber: string;
};

const dooAwbList = (props: DooAwbListProps) => {

  const { classes, awbs } = props;

  return (
    <div id='myTable'>
      { !props.doo.delivered_date && <div className={ classes.plus }>
        <img alt="logo" src={ addIcon } className={ props.classes.manualEntryBtn } onClick={() => props.addAwb()}/>
      </div>}
      <div className={`${ classes.tableSection } ${ classes.ordersPaper } ${ commonStyles.paperTable } ${ commonStyles.SelectTable }`} >
      <MaterialTable
        data = { awbs }

        columns = {[
          { title: 'Airwaybill', cellStyle: { paddingRight: '5px' },
            render: (rowData: PickupOrderAwb) => {
              const hasSpecials = rowData.special_form_data && rowData.special_form_data.specials_form_data;

              return <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                <span style={{ whiteSpace: 'nowrap' }}>{ rowData.code }-{ rowData.number } {rowData.returned? <span style={{color: 'red'}}>Returned to driver</span>: null}</span>
                { (hasSpecials) ? (
                  <span className={`${ commonStyles.dFlex } ${ props.classes.flexSpcl } ${ props.classes.gap4px }`} style={{ marginLeft: '4px' }}>
                    { rowData.special_form_data.specials_form_data.map((special: any, idx: number) => {
                      if (special.value) {
                        return (
                          <span key={idx} className={ props.classes.specials }>
                            <div style={{ backgroundColor: special.color, border: special.border ? `dashed 2px ${special.border}` : '' }} className={`${ commonStyles.specials }`}>
                              <div className={ commonStyles.colorPrimary }>{special.name}</div>
                            </div>
                            <span className={ commonStyles.spTemp }>{special.temp ? special.temp : ''}</span>
                          </span>
                        )
                      }
                      return null;
                    })}
                    { rowData.special_form_data.other.name.length ?
                      rowData.special_form_data.other.name.map((others: string, idx: number) => <div key={`other-${idx}`} style={{ backgroundColor: '#ffffff', border: '1px solid var(--primaryblue)', color: 'var(--primaryblue)' }} className={`${commonStyles.specials}`}>{others}</div>)
                      : null
                    }
                  </span>
                ) : null }
              </span>;
            }
          },
          { title: 'Dest', field: 'dst' },
          { title: 'Flight', cellStyle: { paddingLeft: '5px', paddingRight: '5px' },
            render: (rowData: PickupOrderAwb) => {

              const flightDate: string = Moment(rowData.parts[0].flight_date).format('DDMMM').toUpperCase();
              const flightNumber: string = rowData.parts.length > 1 ? 'PART SHIPMENT' : `${ rowData.parts[0].flight_no }/${ flightDate }`;

              return <span>{ flightNumber }</span>;
            }
          },
          { title: 'Pcs', field: 'pieces' },
          { title: 'Wgt', field: 'weight',
            render: (rowData: PickupOrderAwb) => {

              const weight: number = +(rowData.weight);
              return <span>{ weight.toFixed(1) }K</span>;
            }
          },
          { title: 'Action', headerStyle: { textAlign: 'center' }, cellStyle: { paddingRight: '13px' },
            render: (rowData: PickupOrderAwb) => {
              const iconColor = (rowData.color_status === 'green') ? `${ classes.green }` : `${ classes.red }`;
              return <span style={{ display: 'flex', flexDirection: 'row', width: '95%', justifyContent: 'space-around' }} >
                <Tooltip title="Attach file">
                  <span>
                    <Badge className={ commonStyles.attachmentBadge } color="secondary" badgeContent={ rowData.attachmentCount }>
                      <AttachFile className={ classes.materialIcon } onClick={(events) => props.openDialog('attachments', rowData.code, rowData.number, rowData.version) } />
                    </Badge>
                  </span>
                </Tooltip>
                <Tooltip title="Open R4C checks">
                  <div><p className={ iconColor } onClick={(events) => props.openDialog('rForCheck', rowData.code, rowData.number, rowData.version) } > R4C</p></div>
                </Tooltip>
                <Tooltip title="Print">
                  <Print className={ classes.materialIcon } onClick={ () => props.printAwbInfoClicked(rowData.code, rowData.number, rowData.version) } />
                </Tooltip>
              </span>;
            }
          }
        ]}

        options = {{
          paging: false,
          pageSize: 5,
          maxBodyHeight: '342px',
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15,20],
          toolbar: false,
          sorting: false,
          rowStyle: (rowData: PickupOrderAwb) => ({
            background: (props.selectedAwbNumber === rowData.number && props.changed) ? 'orange' : '#fff',
            transition: '0s',
          })
        }}
      />
      </div>
    </div>
    
  )
}

export default withStyles(styles)(dooAwbList);